import { t } from 'i18n/index';

export const getServiceFeeLabel = (showApplicationFee) => {
    return showApplicationFee ?  t('profile:perks:noHiddenFees'): t('profile:perks:applicationFeesApply')
};